module.exports = __webpack_public_path__ + "static/careersbg-1df3e88fee7240e2f5d461b3cf3cdf68.svg";